import { connect } from 'react-redux'
import ConnectedLegislationFoldersMenu from 'pages/legislationfolders/ConnectedLegislationFoldersMenu'
import { setLegislationFolders, setSignUpModalIsOpen } from 'redux/actions'

const mapStateToProps = state => ({
  isLogged: state.user.isLogged,
  isLoaded: state.placeholders.isTiledMenuLoaded,
  isTiledMenuLoaded: state.placeholders.isTiledMenuLoaded
})

const mapDispatchToProps = dispatch => ({
  setLegislationFolders: legislationFolders => dispatch(setLegislationFolders(legislationFolders)),
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedLegislationFoldersMenu)
